var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vimeo-video"},[_vm._t("default"),_vm._v(" "),_c('vimeo-player',{ref:"player",attrs:{"video-id":_vm.videoID,"player-height":_vm.height,"controls":false,"loop":true,"options":_vm.options},on:{"ready":_vm.onReady}})],2)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d619f3e0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/components/apps/vimeo-component.vue
// module id = 9XYJ
// module chunks = 2